export default "__VITE_ASSET__CcOvVVFg__"